import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { recommendationsStateSelector } from "../recommendationsStateSelector";

export const dismissPeriodSelector = createDraftSafeSelector(
  [recommendationsStateSelector],
  (state) => {
    return state.dismiss.dismissPeriod;
  },
);
